import React, { useState, useEffect, useContext } from "react";
import { useOktaAuth } from "@okta/okta-react";
import axios from "axios";
import pirmLogo from '../../images/pirmLogo.png';
import css from './style.module.css';
import { useLocation, useNavigate } from "react-router-dom";
import { AppContext } from "../../Context/AppContext";
import FirebaseAuthForm from "./FirebaseAuthForm";
import { useOktaConfig } from "../../Context/CredentialsContext";
import { MarktingContext } from "../../Context/MarktingContext";

const Login = () => {
  const { setLoginToken } = useOktaConfig();

  const { setApp, session } = useContext(AppContext);
  const { authState, oktaAuth } = useOktaAuth();
  const [assignedApps, setAssignedApps] = useState('');
  const [error, setError] = useState(null);
  const [spinner, setSpinner] = useState(false);
  const [loginStatus, setLoginStatus] = useState(false);
  const navigate = useNavigate();
  const companyLogo = localStorage.getItem("Company Logo")
  const { setUserTeam } = useContext(MarktingContext);
  const [from, setFrom] = useState("/");


  useEffect(() => {
    if (sessionStorage.getItem('from')) {
      setFrom(sessionStorage.getItem('from'));
    } else {
      setFrom("/");
      sessionStorage.setItem('from', "/");
    }
  }, []);

  useEffect(() => {
    localStorage.removeItem("Vendor User");
  }, []);

  useEffect(() => {
    const checkAuthentication = async () => {
      if (authState?.isAuthenticated && authState.accessToken) {
        setSpinner(true);
        try {
          const info = await oktaAuth.getUser();

          const Application = await getAssignedApplications(info.sub);


          if (Application.length !== 0) {
            session()
          }

          setApp(Application);
          if (Application.length > 0) {

            if (from === "/") {
              navigate("/policies", { replace: true });
            } else {
              navigate(from, { replace: true });
            }

          } else {
            setAssignedApps("You don't have access to this application. Please contact your Okta Administrator.");
          }
        } catch (error) {
          // console.error("Error fetching user info:", error);
          setError("Error fetching user info");
        } finally {
          setSpinner(false);
        }
      } else {
        setAssignedApps(null);
      }
    };

    checkAuthentication();
  }, [authState, oktaAuth, navigate]);

  // FRONTEND: Fixed getAssignedApplications function
  const getAssignedApplications = async (user) => {
    const tokenStorage = localStorage.getItem("okta-token-storage");
    setLoginToken(JSON.parse(localStorage.getItem("okta-token-storage"))?.accessToken?.accessToken);

    if (!tokenStorage) {
      setError("No token storage found.");
      return [];
    }

    const { accessToken } = JSON.parse(tokenStorage);
    if (!accessToken) {
      setError("No access token found.");
      return [];
    }

    setSpinner(true);

    try {
      // FIX: Use accessToken.accessToken directly instead of JSON.stringify(accessToken)
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/react`,
        { userId: user },
        {
          headers: {
            Authorization: `Bearer ${accessToken.accessToken}`,
          },
        }
      );
      if (response.status === 200) {
        sessionStorage.setItem('Team', response.data.userRole);
        setUserTeam(response.data.userRole);
      }

      setSpinner(false);
      return response.data.Assigned_Applications;
    } catch (error) {
      setError("Error fetching assigned applications");
      setSpinner(false);
      return [];
    }
  };


  const login = () => {
    setLoginStatus(true);
    oktaAuth.signInWithRedirect({ originalUri: "/" });
  }

  return (

    <div className={`rounded documents ${css.borderForm}`}>
      <header className={`text-primary py-3 fw-bold px-5 mt-2 border-bottom border-1 ${css.headerBottomLineColor} rounded-top text-center`} >
        <img src={companyLogo || pirmLogo} alt="Company logo" className={css.logo} />
      </header>
      <main className="py-3 text-center px-4">
        <p className="text-center fw-bold mt-4 mb-2" style={{ fontWeight: 400, fontSize: "1.25rem" }}>
          Compliance Portal
        </p>
        {/* {error && <p className="text-danger fw-bold mt-2 mb-0">{error}</p>} */}
        <div className="my-3">
          <FirebaseAuthForm from={from} loginStatus={loginStatus} setLoginStatus={setLoginStatus} session={session} setLoginToken={setLoginToken} />

        </div>
        {assignedApps && <p className="text-danger fw-bold px-4">{assignedApps}</p>}
        <span id="Line" className={css.loginLine}>or sign in with</span>
        <button
          onClick={login}
          className="btn text-white my-4 rounded-1 w-100"
          style={{ backgroundColor: "var(--accent)" }}
          disabled={loginStatus} // Disable based on loginStatus
        >
          OKTA
          {spinner && <i className="ms-3 fas fa-spinner fa-pulse"></i>}
        </button>
      </main>
    </div>

  );
};

export default Login;
